var _path, _rect, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 12.7622C4 12.0797 4.34806 11.4443 4.92322 11.0768L14.9232 4.68794C15.5798 4.26846 16.4202 4.26847 17.0768 4.68794L27.0768 11.0768C27.6519 11.4443 28 12.0797 28 12.7622V25C28 26.1046 27.1046 27 26 27H6C4.89543 27 4 26.1046 4 25V12.7622Z",
    fill: "#DBD6FD"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 16,
    height: 16,
    fill: "#6F5FD4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.22425 12.1191C4.07915 12.3991 4 12.7138 4 13.0393V24.999C4 26.1036 4.89543 26.999 6 26.999H25.9988C27.1034 26.999 27.9988 26.1036 27.9988 24.999V13.0393C27.9988 12.7138 27.9197 12.3991 27.7746 12.1191L15.9994 18.2128L4.22425 12.1191Z",
    fill: "#AFA5EE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.97286 27C5.45253 26.9921 4.98037 26.7855 4.62891 26.4528L14.6896 17.648C14.7184 17.6228 14.7477 17.5986 14.7777 17.5752L15.0838 17.7336C15.6603 18.032 16.3458 18.032 16.9224 17.7336L17.2284 17.5752C17.2584 17.5986 17.2878 17.6228 17.3165 17.648L27.3773 26.4528C27.0258 26.7855 26.5536 26.9921 26.0333 27H5.97286Z",
    fill: "#5C4EB1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.27c47ca15310e2002646d1cb9237b687.svg";
export { ForwardRef as ReactComponent };